import { render, staticRenderFns } from "./StrategyDisplayCard.vue?vue&type=template&id=703bcff4&scoped=true"
import script from "./StrategyDisplayCard.vue?vue&type=script&lang=js"
export * from "./StrategyDisplayCard.vue?vue&type=script&lang=js"
import style0 from "./StrategyDisplayCard.vue?vue&type=style&index=0&id=703bcff4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703bcff4",
  null
  
)

export default component.exports